import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { FAQS } from "@/data/site";
import { FadeUp, Chapter, RevealLines, EASE } from "./motion";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="bg-[#E7DDD0]/50 py-24 md:py-36">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 md:px-12 lg:grid-cols-[1fr_1.5fr]">
        <div className="lg:sticky lg:top-32 lg:self-start">
          <Chapter num="13" title="Questions" />
          <RevealLines
            className="mt-8 font-display text-4xl tracking-tight text-[#1B1B1B] md:text-5xl"
            lines={[<>Asked <span className="italic text-[#B68D40]">often,</span></>, <>answered honestly.</>]}
          />
        </div>
        <div>
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <FadeUp key={i} delay={i * 0.05}>
                <div className="border-t hairline last:border-b">
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    data-testid={`faq-${i}`}
                    className="flex w-full items-center justify-between gap-6 py-7 text-left"
                  >
                    <span className={`font-display text-lg transition-colors duration-300 md:text-xl ${isOpen ? "text-[#B68D40]" : "text-[#1B1B1B]"}`}>
                      {f.q}
                    </span>
                    <motion.span
                      animate={{ rotate: isOpen ? 45 : 0 }}
                      transition={{ duration: 0.35, ease: EASE }}
                      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border ${isOpen ? "border-[#B68D40] text-[#B68D40]" : "hairline text-[#2C2C2C]/50"}`}
                    >
                      <Plus size={15} />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.45, ease: EASE }}
                        className="overflow-hidden"
                      >
                        <p className="max-w-2xl pb-7 text-sm leading-relaxed text-[#2C2C2C]/65">{f.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
}
